export type ProfitabilityLine = {
  revenue: number | null;
  material: number | null;
  labour: number | null;
};

type ExactProfitability = {
  external: {contribution: number | null; gm: number | null};
  artemisCrew: {contribution: number | null; gm: number | null};
};

export type ProposalProfitability = {
  externalProfit: number | null;
  externalMargin: number | null;
  crewProfit: number | null;
  crewMargin: number | null;
  pricedLines: number;
  totalLines: number;
  complete: boolean;
};

/**
 * Staff estimate from the engine's own line evidence.
 *
 * Correction, 27 October: partial-line profit is not whole-quote profit. An unresolved item
 * leaves the quote profit unknown. Own-crew profit needs approved work-item costs; zero labour
 * cannot establish a bonus. The complete saved cost review supplies that evidence.
 */
export function proposalProfitability(lines: ProfitabilityLine[], exact: ExactProfitability | null): ProposalProfitability {
  const known = lines.filter(line => line.revenue !== null && line.material !== null && line.labour !== null);
  const complete = lines.length > 0 && known.length === lines.length;
  if (complete && exact && exact.external.contribution !== null) {
    return {
      externalProfit: exact.external.contribution,
      externalMargin: exact.external.gm,
      crewProfit: null,
      crewMargin: null,
      pricedLines: known.length,
      totalLines: lines.length,
      complete: true,
    };
  }
  if (!complete) {
    return {externalProfit:null,externalMargin:null,crewProfit:null,crewMargin:null,pricedLines:0,totalLines:lines.length,complete:false};
  }
  const revenue = known.reduce((sum,line)=>sum+(line.revenue??0),0);
  const material = known.reduce((sum,line)=>sum+(line.material??0),0);
  const labour = known.reduce((sum,line)=>sum+(line.labour??0),0);
  const externalProfit = Math.round((revenue-material-labour)*100)/100;
  const crewProfit = null;
  return {
    externalProfit,
    externalMargin: revenue>0?Math.round((externalProfit/revenue)*10000)/10000:null,
    crewProfit,
    crewMargin: null,
    pricedLines: known.length,
    totalLines: lines.length,
    complete,
  };
}
